export default __webpack_public_path__ + "static/media/Instruct.e405cacc.mov";